	<template>
		<div class="ai_container">
			<Header :onPrev="handlePrev" />
			<div class="ai_wrapper">
				<h3 class="heading_4">
					차량 사진 제공 방식을<br />선택해 주세요.
				</h3>
				<div class="choose_method_wrapper">
					<CheckBox :type="'radio'" :value="method==='takePhoto'" :onClick="() => toggleMethod('takePhoto')">
						<div class="method_item_wrapper">
							<div class="method_image_wrapper">
								<img src="/static/images/ai/take_photo.png" width="50" alt="사진촬영" />
							</div>
							<div>
								<b class="heading_7">직접 사진 촬영</b>
								<p class="body_8 f_gray_4">촬영가이드에 맞춰 직접 촬영</p>
							</div>
						</div>
					</CheckBox>
					<CheckBox :type="'radio'" :value="method==='upload'" :onClick="() => toggleMethod('upload')">						
						<div class="method_item_wrapper">
							<div class="method_image_wrapper">
								<img src="/static/images/ai/upload.png" width="50" alt="업로드" />
							</div>
							<div>
								<b class="heading_7">사진 업로드</b>
								<p class="body_8 f_gray_4">이미 촬영한 사진을 업로드</p>
							</div>
						</div>
					</CheckBox>
				</div>
				<p class="">• 좀 더 정확한 AI견적 산정을 위해 직접 촬영을 권장드려요.</p>
			</div>
			<BottomFloatButton label="다음" :onClick="handleNext" :isFull="false" />
		</div>
	</template>

<script>
import Vue from 'vue'
import Header from '../../components/ai/AiHeader.vue'
import BottomFloatButton from '../../components/ai/AiBottomFloatButton.vue'
import CheckBox from '@/components/ai/AiCheckBox.vue'

export default {
	name: 'AiChooseMethod',
	components: {
		Header,
		BottomFloatButton,
		CheckBox
	},
	data(){
		return{
			method: 'takePhoto'
		}
	},
	methods: {
		handlePrev() {
			this.$router.push({ name: 'AiSearchCar' })
		},
		toggleMethod(method) {
			this.method = method
		},
		handleNext(){
			if(this.method === 'takePhoto'){
				this.$router.push({ name: 'AiCreate' })
			} else {
				this.$router.push({ name: 'AiUpload' })
			}
		}
	},
}
</script>




// WEBPACK FOOTER //
// src/views/ai/AiChooseMethod.vue